export const FETCH_EMPLOYEE_SALARY_DEFINITION = "FETCH_EMPLOYEE_SALARY_DEFINITION";
export const FETCH_EMPLOYEE_SALARY_DEFINITION_SUCCESS = "FETCH_EMPLOYEE_SALARY_DEFINITION_SUCCESS";
export const FETCH_EMPLOYEE_SALARY_DEFINITION_FAILURE = "FETCH_EMPLOYEE_SALARY_DEFINITION_FAILURE";
export const FETCH_EMPLOYEE_SALARY_DEFINITION_CLEAR = "FETCH_EMPLOYEE_SALARY_DEFINITION_CLEAR";

export const SAVE_EMPLOYEE_SALARY_DEFINITION = "SAVE_EMPLOYEE_SALARY_DEFINITION";
export const SAVE_EMPLOYEE_SALARY_DEFINITION_SUCCESS = "SAVE_EMPLOYEE_SALARY_DEFINITION_SUCCESS";
export const SAVE_EMPLOYEE_SALARY_DEFINITION_FAILURE = "SAVE_EMPLOYEE_SALARY_DEFINITION_FAILURE";

export const FETCH_EMPLOYEE_SALARY_INCREMENT = "FETCH_EMPLOYEE_SALARY_INCREMENT";
export const FETCH_EMPLOYEE_SALARY_INCREMENT_SUCCESS = "FETCH_EMPLOYEE_SALARY_INCREMENT_SUCCESS";
export const FETCH_EMPLOYEE_SALARY_INCREMENT_FAILURE = "FETCH_EMPLOYEE_SALARY_INCREMENT_FAILURE";

export const FETCH_FINANCIAL_INCREMENT_TYPES = "FETCH_FINANCIAL_INCREMENT_TYPES";
export const FETCH_FINANCIAL_INCREMENT_TYPES_SUCCESS = "FETCH_FINANCIAL_INCREMENT_TYPES_SUCCESS";
export const FETCH_FINANCIAL_INCREMENT_TYPES_FAILURE = "FETCH_FINANCIAL_INCREMENT_TYPES_FAILURE";

export const FETCH_LOAN_TYPES = "FETCH_LOAN_TYPES";
export const FETCH_LOAN_TYPES_SUCCESS = "FETCH_LOAN_TYPES_SUCCESS";
export const FETCH_LOAN_TYPES_FAILURE = "FETCH_LOAN_TYPES_FAILURE";

export const FETCH_LOAN_LOANNUMBER = "FETCH_LOAN_LOANNUMBER";
export const FETCH_LOAN_LOANNUMBER_SUCCESS = "FETCH_LOAN_LOANNUMBER_SUCCESS";
export const FETCH_LOAN_LOANNUMBER_FAILURE = "FETCH_LOAN_LOANNUMBER_FAILURE";

export const FETCH_LOAN_MONTHLY_INSTALLMENTS = "FETCH_LOAN_MONTHLY_INSTALLMENTS";
export const FETCH_LOAN_MONTHLY_INSTALLMENTS_SUCCESS = "FETCH_LOAN_MONTHLY_INSTALLMENTS_SUCCESS";
export const FETCH_LOAN_MONTHLY_INSTALLMENTS_FAILURE = "FETCH_LOAN_MONTHLY_INSTALLMENTS_FAILURE";

export const SAVE_LOAN_MONTHLY_INSTALLMENTS = "SAVE_LOAN_MONTHLY_INSTALLMENTS";
export const SAVE_LOAN_MONTHLY_INSTALLMENTS_SUCCESS = "SAVE_LOAN_MONTHLY_INSTALLMENTS_SUCCESS";
export const SAVE_LOAN_MONTHLY_INSTALLMENTS_FAILURE = "SAVE_LOAN_MONTHLY_INSTALLMENTS_FAILURE";

export const RESET_SAVE_STATUS = "RESET_SAVE_STATUS";

export const FETCH_EMPLOYEE_LOAN_LISTS = "FETCH_EMPLOYEE_LOAN_LISTS";
export const FETCH_EMPLOYEE_LOAN_LISTS_SUCCESS = "FETCH_EMPLOYEE_LOAN_LISTS_SUCCESS";
export const FETCH_EMPLOYEE_LOAN_LISTS_FAILURE = "FETCH_EMPLOYEE_LOAN_LISTS_FAILURE";

export const FETCH_EMPLOYEE_LOAN_INSTALLMENTS = "FETCH_EMPLOYEE_LOAN_INSTALLMENTS";
export const FETCH_EMPLOYEE_LOAN_INSTALLMENTS_SUCCESS = "FETCH_EMPLOYEE_LOAN_INSTALLMENTS_SUCCESS";
export const FETCH_EMPLOYEE_LOAN_INSTALLMENTS_FAILURE = "FETCH_EMPLOYEE_LOAN_INSTALLMENTS_FAILURE";

export const SAVE_EMPLOYEE_SALARY_INCREMENT_CTC = "SAVE_EMPLOYEE_SALARY_INCREMENT_CTC";
export const SAVE_EMPLOYEE_SALARY_INCREMENT_CTC_SUCCESS = "SAVE_EMPLOYEE_SALARY_INCREMENT_CTC_SUCCESS";
export const SAVE_EMPLOYEE_SALARY_INCREMENT_CTC_FAILURE = "SAVE_EMPLOYEE_SALARY_INCREMENT_CTC_FAILURE";
export const RESET_SAVE_INCREMENT_STATUS = "RESET_SAVE_INCREMENT_STATUS";

export const FETCH_EMPLOYEE_SALARY_INCREMENT_SAVED_CTC = "FETCH_EMPLOYEE_SALARY_INCREMENT_SAVED_CTC";
export const FETCH_EMPLOYEE_SALARY_INCREMENT_SAVED_CTC_SUCCESS = "FETCH_EMPLOYEE_SALARY_INCREMENT_SAVED_CTC_SUCCESS";
export const FETCH_EMPLOYEE_SALARY_INCREMENT_SAVED_CTC_FAILURE = "FETCH_EMPLOYEE_SALARY_INCREMENT_SAVED_CTC_FAILURE";

export const FETCH_EMPLOYEE_INCREMENT_APPROVAL_CTC = "FETCH_EMPLOYEE_INCREMENT_APPROVAL_CTC";
export const FETCH_EMPLOYEE_INCREMENT_APPROVAL_CTC_SUCCESS = "FETCH_EMPLOYEE_INCREMENT_APPROVAL_CTC_SUCCESS";
export const FETCH_EMPLOYEE_INCREMENT_APPROVAL_CTC_FAILURE = "FETCH_EMPLOYEE_INCREMENT_APPROVAL_CTC_FAILURE";

export const SAVE_EMPLOYEE_INCREMENT_APPROVAL_CTC = "SAVE_EMPLOYEE_INCREMENT_APPROVAL_CTC";
export const SAVE_EMPLOYEE_INCREMENT_APPROVAL_CTC_SUCCESS = "SAVE_EMPLOYEE_INCREMENT_APPROVAL_CTC_SUCCESS";
export const SAVE_EMPLOYEE_INCREMENT_APPROVAL_CTC_FAILURE = "SAVE_EMPLOYEE_INCREMENT_APPROVAL_CTC_FAILURE";

export const FETCH_EMPLOYEE_INCREMENT_REPORT = "FETCH_EMPLOYEE_INCREMENT_REPORT";
export const FETCH_EMPLOYEE_INCREMENT_REPORT_SUCCESS = "FETCH_EMPLOYEE_INCREMENT_REPORT_SUCCESS";
export const FETCH_EMPLOYEE_INCREMENT_REPORT_FAILURE = "FETCH_EMPLOYEE_INCREMENT_REPORT_FAILURE";

export const FETCH_EMPLOYEE_LOAN_NO_PRECLOSE = "FETCH_EMPLOYEE_LOAN_PRECLOSE";
export const FETCH_EMPLOYEE_LOAN_NO_PRECLOSE_SUCCESS = "FETCH_EMPLOYEE_LOAN_PRECLOSE_SUCCESS";
export const FETCH_EMPLOYEE_LOAN_NO_PRECLOSE_FAILURE = "FETCH_EMPLOYEE_LOAN_PRECLOSE_FAILURE";

export const FETCH_EMPLOYEE_PRECLOSE = "FETCH_EMPLOYEE_PRECLOSE";
export const FETCH_EMPLOYEE_PRECLOSE_SUCCESS = "FETCH_EMPLOYEE_PRECLOSE_SUCCESS";
export const FETCH_EMPLOYEE_PRECLOSE_FAILURE = "FETCH_EMPLOYEE_PRECLOSE_FAILURE";

export const SAVE_LOAN_PRECLOSE = "SAVE_LOAN_PRECLOSE";
export const SAVE_LOAN_PRECLOSE_SUCCESS = "SAVE_LOAN_PRECLOSE_SUCCESS";
export const SAVE_LOAN_PRECLOSE_FAILURE = "SAVE_LOAN_PRECLOSE_FAILURE";

export const SAVE_EMPLOYEE_LOAN_FREEZE = "SAVE_EMPLOYEE_LOAN_FREEZE";
export const SAVE_EMPLOYEE_LOAN_FREEZE_SUCCESS = "SAVE_EMPLOYEE_LOAN_FREEZE_SUCCESS";
export const SAVE_EMPLOYEE_LOAN_FREEZE_FAILURE = "SAVE_EMPLOYEE_LOAN_FREEZE_FAILURE";

export const FETCH_EMPLOYEE_LOAN_FREEZE = "FETCH_EMPLOYEE_LOAN_FREEZE";
export const FETCH_EMPLOYEE_LOAN_FREEZE_SUCCESS = "FETCH_EMPLOYEE_LOAN_FREEZE_SUCCESS";
export const FETCH_EMPLOYEE_LOAN_FREEZE_FAILURE = "FETCH_EMPLOYEE_LOAN_FREEZE_FAILURE";

export const FETCH_EMPLOYEE_LOAN_APPOVAL = "FETCH_EMPLOYEE_LOAN_APPOVAL";
export const FETCH_EMPLOYEE_LOAN_APPOVAL_SUCCESS = "FETCH_EMPLOYEE_LOAN_APPOVAL_SUCCESS";
export const FETCH_EMPLOYEE_LOAN_APPOVAL_FAILURE = "FETCH_EMPLOYEE_LOAN_APPOVAL_FAILURE";

export const SAVE_EMPLOYEE_LOAN_APPOVALS = "SAVE_EMPLOYEE_LOAN_APPOVALS";
export const SAVE_EMPLOYEE_LOAN_APPOVALS_SUCCESS = "SAVE_EMPLOYEE_LOAN_APPOVALS_SUCCESS";
export const SAVE_EMPLOYEE_LOAN_APPOVALS_FAILURE = "SAVE_EMPLOYEE_LOAN_APPOVALS_FAILURE";

export const FETCH_SALARY_GEN_SCALE = "FETCH_SALARY_GEN_SCALE";
export const FETCH_SALARY_GEN_SCALE_SUCCESS = "FETCH_SALARY_GEN_SCALE_SUCCESS";
export const FETCH_SALARY_GEN_SCALE_FAILURE = "FETCH_SALARY_GEN_SCALE_FAILURE";

export const SAVE_SALARY_GENERATION = "SAVE_SALARY_GENERATION";
export const SAVE_SALARY_GENERATION_SUCCESS = "SAVE_SALARY_GENERATION_SUCCESS";
export const SAVE_SALARY_GENERATION_FAILURE = "SAVE_SALARY_GENERATION_FAILURE";

export const SAVE_SALARY_GENERATION_LEAVE_APPROVALS = "SAVE_SALARY_GENERATION_LEAVE_APPROVALS";
export const SAVE_SALARY_GENERATION_LEAVE_APPROVALS_SUCCESS = "SAVE_SALARY_GENERATION_LEAVE_APPROVALS_SUCCESS";
export const SAVE_SALARY_GENERATION_LEAVE_APPROVALS_FAILURE = "SAVE_SALARY_GENERATION_LEAVE_APPROVALS_FAILURE";

export const SAVE_SALARY_GENERATE = "SAVE_SALARY_GENERATE";
export const SAVE_SALARY_GENERATE_SUCCESS = "SAVE_SALARY_GENERATE_SUCCESS";
export const SAVE_SALARY_GENERATE_FAILURE = "SAVE_SALARY_GENERATE_FAILURE";

export const CLEAR_APPROVE_ERROR = "CLEAR_APPROVE_ERROR";

export const FETCH_SALARY_LOGS = "FETCH_SALARY_LOGS";
export const FETCH_SALARY_LOGS_SUCCESS = "FETCH_SALARY_LOGS_SUCCESS";
export const FETCH_SALARY_LOGS_FAILURE = "FETCH_SALARY_LOGS_FAILURE";